<ng-container *transloco="let t">
  <section class="shipping-estimate-card">
    <div class="flex flex-col justify-center align-center icon-box" aria-hidden="true">
      <popsy-icon-shipping-box class="icon gray-dark"></popsy-icon-shipping-box>
    </div>
    <span class="fixed-space-24" aria-hidden="true"></span>
    <div class="flex flex-col justify-center align-start content">
      <div class="flex flex-row align-base">
        @if (lang() === 'en') {
          <span class="title">Shipping fee:</span>
        } @else {
          <span class="title">رسوم الشحن:</span>
        }
        <span class="fixed-space-8" aria-hidden="true"></span>

        <span class="small crossed">{{ deliveryPriceFallback() | amount }}</span>
        <span class="fixed-space-8" aria-hidden="true"></span>
        <span class="price free bold">{{ t('label_free') }}</span>
      </div>
      <popsy-skeleton class="mock" *ngIf="!(deliveryEstimate$ | async)"></popsy-skeleton>
      <span> {{ t('label_deliver_by') }} {{ deliveryEstimate$ | async }} </span>
    </div>
  </section>
</ng-container>
